import { useParams } from 'react-router-dom';
import { useGetRoleQuery } from '../../../api/queries/getRole';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import RoleInnerPage from './RoleInnerPage';

const RoleDetailsPage = () => {
    const { roleId } = useParams<{ roleId: string }>();

    const { data, loading } = useGetRoleQuery({
        fetchPolicy: 'cache-and-network',
        variables: { roleId },
    });

    const role = data?.role;

    if (!role && loading) {
        return <LoadingElement />;
    }

    if (!role) {
        return <NotFoundResult />;
    }

    return <RoleInnerPage role={role} />;
};

export default RoleDetailsPage;
